import {
   CurrentHealthcareOrganizationQuery,
   HealthcareOrganization,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../translations';

type HealthcareOrganizationPanelLoaderRenderProps = {
   healthcareOrganization: HealthcareOrganization;
};

type HealthcareOrganizationPanelLoaderProps = {
   readonly children: (renderProps: HealthcareOrganizationPanelLoaderRenderProps) => JSX.Element;
};

export const HealthcareOrganizationPanelLoader = (props: HealthcareOrganizationPanelLoaderProps): JSX.Element => {
   const {
      data: healthcareOrganization,
      loading: healthcareOrganizationLoading,
      error: healthcareOrganizationError,
   } = useCqrsGet<HealthcareOrganization>(() => new CurrentHealthcareOrganizationQuery());

   if (healthcareOrganizationLoading) {
      return <LoaderSpinner />;
   }

   if (healthcareOrganizationError) {
      return (
         <Message
            testId={'failedToFetchHealthcareOrganization'}
            label={healthcareOrganizationTranslationKeys.failedToFetchHealthcareOrganization}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      healthcareOrganization: healthcareOrganization,
   });
};
